import { Button } from '@flixbus/honeycomb-react';
import { Icon, IconCopy } from '@flixbus/honeycomb-icons-react';

import { useNotification } from '../Notifications/Context';

import styles from './copy-voucher-code.module.scss';

type CopyVoucherCodeProps = {
  code: string;
  showLabel?: boolean;
};

const CopyVoucherCode = ({ code, showLabel = true }: CopyVoucherCodeProps) => {
  const { pushToast } = useNotification();

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      pushToast({ message: 'Copied to clipboard!', status: 'success' });
    } catch {
      pushToast({ message: 'Failed to copy voucher code', status: 'danger' });
    }
  };

  return (
    <Button
      appearance='link'
      extraClasses={styles.copyButton}
      onClick={handleCopy}
      aria-label='Copy voucher code'
      title='Copy voucher code'
    >
      <Icon InlineIcon={IconCopy} />
      {showLabel && 'Copy'}
    </Button>
  );
};

export default CopyVoucherCode;
